module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Google Pay-5ef693183fe785f5c30f4bda0f89bc5d.svg";